module.exports = __webpack_public_path__ + "static/media/user.8db51090.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/user.svg
// module id = 555
// module chunks = 0